<template>
  <div class="p-progress-circular indeterminate">
    <svg
      :height="radius * 2"
      :width="radius * 2"
    >
      <circle
        stroke="black"
        fill="transparent"
        :stroke-dasharray="circumference + ' ' + circumference"
        :style="{ strokeDashoffset }"
        :stroke-width="stroke"
        :r="normalizedRadius"
        :cx="radius"
        :cy="radius"
      />
    </svg>
  </div>
</template>

<script lang="ts">
  import mixins from '../../mixins';
  // TODO: WIP
  export default mixins().extend({
    props: {
      indeterminate: { default: false, type: Boolean },
      radius: { default: 10, type: Number },
      progress: { default: 0, type: Number },
      stroke: { default: 1, type: Number },
    },
    data() {
      const normalizedRadius = this.radius - this.stroke * 2;
      const circumference = normalizedRadius * 2 * Math.PI;

      return {
        normalizedRadius: normalizedRadius as number,
        circumference: circumference as number,
      };
    },
    computed: {
      strokeDashoffset() {
        return (this as any).circumference - (this as any).progress * (this as any).circumference;
      },
    },
  });
</script>
